import { CodedDomainItem } from "./codedDomainItem.class";

export class CodedDomainWorkOrderType extends CodedDomainItem {
    divisionId: number;

    constructor(name: string, value: string, divisionId: number) {
        super(name, value);
        this.divisionId = divisionId;
    }
}